import { Grid, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import React from "react";
import { Controller } from "react-hook-form";

const OtherSecurityClient = ({
  countryMismatch,
  blockedUser,
  blockedIp,
  setValue,
  isEdit,
}) => {
  return (
    <MDBox
      p={2}
      style={{ border: "1px solid #D9D9D9", borderRadius: "16px" }}
      mt={2}
    >
      <MDTypography variant="h6" fontWeight="medium" color="textColor">
        {"Other Security"}
      </MDTypography>
      <MDBox mt={0.5}>
        <hr style={{ border: "1px solid #e0e0e0", width: "100%" }} />
      </MDBox>
      <Grid container spacing={3} px={2} pt={2}>
        <Grid item xs={12} md={12} lg={3}>
          <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
            <MDBox ml={0.5}>
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="dark"
                fontSize="12px"
              >
                Country mismatch
              </MDTypography>
            </MDBox>
            <MDBox mt={0.5}>
              <Switch
                checked={countryMismatch}
                onChange={(e, value) => {
                  setValue("countryMismatch", value);
                }}
                disabled={isEdit.disabled}
              />
            </MDBox>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={12} lg={3}>
          <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
            <MDBox ml={0.5}>
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="dark"
                fontSize="12px"
              >
                Blocked User
              </MDTypography>
            </MDBox>
            <MDBox mt={0.5}>
              <Switch
                checked={blockedUser}
                onChange={(e, value) => {
                  setValue("blockedUser", value);
                }}
                disabled={isEdit.disabled}
              />
            </MDBox>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={12} lg={3}>
          <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
            <MDBox ml={0.5}>
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="dark"
                fontSize="12px"
              >
                Blocked Ip
              </MDTypography>
            </MDBox>
            <MDBox mt={0.5}>
              <Switch
                checked={blockedIp}
                onChange={(e, value) => {
                  setValue("blockedIp", value);
                }}
                disabled={isEdit.disabled}
              />
            </MDBox>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default OtherSecurityClient;
